import React from 'react';
import { Fire, Trophy } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

const StreakBadge = ({ streak = 0, className = '' }) => {
  // Determine badge style based on streak length
  const getBadgeStyle = () => {
    if (streak >= 30) {
      return {
        gradient: 'from-amber-400 via-orange-500 to-red-500',
        icon: Trophy,
        label: 'Legendary',
        glow: 'shadow-lg shadow-amber-500/30'
      };
    } else if (streak >= 14) {
      return {
        gradient: 'from-orange-500 to-red-500',
        icon: Fire,
        label: 'On Fire',
        glow: 'shadow-lg shadow-orange-500/30'
      };
    } else if (streak >= 7) {
      return {
        gradient: 'from-yellow-500 to-orange-500',
        icon: Fire,
        label: 'Hot',
        glow: 'shadow-md shadow-yellow-500/20'
      };
    } else if (streak >= 3) {
      return {
        gradient: 'from-blue-500 to-purple-500',
        icon: Fire,
        label: 'Warming Up',
        glow: ''
      };
    } else {
      return {
        gradient: 'from-slate-500 to-slate-600',
        icon: Fire,
        label: 'Start',
        glow: ''
      };
    }
  };

  const style = getBadgeStyle();
  const Icon = style.icon;

  if (streak <= 0) return null;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
      className={`inline-flex items-center space-x-2 px-4 py-2 bg-gradient-to-r ${style.gradient} rounded-full ${style.glow} ${className}`}
      data-testid="streak-badge"
    >
      <motion.div
        animate={streak >= 7 ? { 
          scale: [1, 1.2, 1],
        } : {}}
        transition={{ 
          duration: 1.5,
          repeat: Infinity,
          repeatType: 'loop'
        }}
      >
        <Icon 
          size={20} 
          weight="fill" 
          className="text-white" 
        />
      </motion.div>
      <span className="text-white font-bold">
        {streak} Day{streak !== 1 ? 's' : ''}
      </span>
      {streak >= 7 && (
        <span className="text-white/80 text-sm font-medium">
          {style.label}!
        </span>
      )}
    </motion.div>
  );
};

export default StreakBadge;
